import ExternalUtil from '../ExternalUtil';
import ServiceEndpointsUtil from './ServiceEndpointsUtil';

/**
 * The `return_to` used in signin redirects https://sso.onshape.com/sso?id=www&return_to=abc123
 * which returns the user to https://www.onshape.com/global-assets/cross-session-redirect.jsp?return_to=abc123
 */
type CadLoginReturnTo = 'upgrade-render-studio' | 'upgrade-educator' | 'default';

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export default class RedirectUtil {
  /** Get the product login url for dev/stage/lve */
  private static getLoginUrl({ returnTo }: { returnTo?: CadLoginReturnTo }): string {
    const prodPath = 'https://sso.onshape.com/sso';
    const base =
      ExternalUtil.isProduction() ? prodPath : (
        `${ServiceEndpointsUtil.mapDomain('https://sso.onshape.com')}/sso`
      );
    const baseUrl = new URL(base);
    if (returnTo) {
      baseUrl.searchParams.set('id', 'www');
      baseUrl.searchParams.set('return_to', returnTo);
    }
    return baseUrl.href;
  }

  /**
   * redirect to the product login page
   *
   * @param delay is the min time in milliseconds to wait before redirect to the login page
   */
  public static redirectToLogin({
    delay,
    returnTo,
  }: {
    delay: number;
    returnTo?: CadLoginReturnTo;
  }): void {
    const loginUrl = RedirectUtil.getLoginUrl({ returnTo });
    setTimeout(() => {
      document.location = loginUrl;
    }, delay);
  }

  /** Redirect to password reset page */
  public static redirectToPasswordReset() {
    const mappedDomain = `${ServiceEndpointsUtil.mapDomain('https://cad.onshape.com')}`;
    const url = `${mappedDomain}/signup/forgotpassword`;
    setTimeout(() => {
      document.location = url;
    }, 2500);
  }

  /** generic redirect to */
  public static redirectTo({ target, delay }: { target: string; delay: number }) {
    setTimeout(() => {
      document.location = target;
    }, delay);
  }
}
